var SYSTEMS = {
    MAIN_POWER: "Main Power",
    AUXILIARY_POWER: "Auxiliary Power",
    HELM: "Helm",
    FUEL_REGULATION: "Fuel Regulation",
    FTL_COMPUTER: "FTL Computer",
    FTL_DRIVE: "FTL Drive",
    MAIN_THRUSTERS: "Main Thrusters",
    POWER_CONDUITS: "Power Conduits",
    MANUVERING_THRUSTERS: "Manuvering Thrusters",
    WEAPONS: "Weapons",
    SHIELDS: "Shields",
    INTERNAL_SCANNERS: "Internal Scanners",
    LONG_RANGE_SCANNERS: "Long Range Scanners",
    SHORT_RANGE_SCANNERS: "Short Range Scanners",
    LANDING_GEAR: "Landing Gear",
    OXYGEN_GENERATION: "Oxygen Generation",
    FOOD_PRODUCTION: "Food Production",
    WASTE_PROCESSING: "Waste Processing",
    SMALL_SCALE_MANUFACTURING: "Small Scale Manufacturing",
    LARGE_SCALE_MANUFACTURING: "Large Scale Manufacturing",
    TELEPORTER: "Teleporter",
    TRACTOR_BEAM: "Tractor Beam",
    DOOR_CONTROL: "Door Control",
    UNIVERSAL_TRANSLATOR: "Universal Translator",
    AIRLOCK: "Airlock",
    DOCKING_CLAMPS: "Docking Clamps",
    AUTOPILOT: "Autopilot",
    EMERGENCY_LIGHTING: "Emergency Lighting",
}

module.exports = {
    SYSTEMS: SYSTEMS,
    ALL_SYSTEMS: [
        {
            key: SYSTEMS.MAIN_POWER,
        },
        {
            key: SYSTEMS.AUXILIARY_POWER,
        },
        {
            key: SYSTEMS.HELM,
        },
        {
            key: SYSTEMS.FUEL_REGULATION,
        },
        {
            key: SYSTEMS.FTL_COMPUTER,
        },
        {
            key: SYSTEMS.FTL_DRIVE,
        },
        {
            key: SYSTEMS.MAIN_THRUSTERS,
        },
        {
            key: SYSTEMS.POWER_CONDUITS,
        },
        {
            key: SYSTEMS.MANUVERING_THRUSTERS,
        },
        {
            key: SYSTEMS.WEAPONS,
        },
        {
            key: SYSTEMS.SHIELDS,
        },
        {
            key: SYSTEMS.INTERNAL_SCANNERS,
        },
        {
            key: SYSTEMS.LONG_RANGE_SCANNERS,
        },
        {
            key: SYSTEMS.SHORT_RANGE_SCANNERS,
        },
        {
            key: SYSTEMS.LANDING_GEAR,
        },
        {
            key: SYSTEMS.OXYGEN_GENERATION,
        },
        {
            key: SYSTEMS.FOOD_PRODUCTION,
        },
        {
            key: SYSTEMS.WASTE_PROCESSING,
        },
        {
            key: SYSTEMS.SMALL_SCALE_MANUFACTURING,
        },
        {
            key: SYSTEMS.LARGE_SCALE_MANUFACTURING,
        },
        {
            key: SYSTEMS.TELEPORTER,
        },
        {
            key: SYSTEMS.TRACTOR_BEAM,
        },
        {
            key: SYSTEMS.DOOR_CONTROL,
        },
        {
            key: SYSTEMS.UNIVERSAL_TRANSLATOR,
        },
        {
            key: SYSTEMS.AIRLOCK,
        },
        {
            key: SYSTEMS.DOCKING_CLAMPS,
        },
        {
            key: SYSTEMS.AUTOPILOT,
        },
        {
            key: SYSTEMS.EMERGENCY_LIGHTING,
        },
    ],
}



// WEBPACK FOOTER //
// ./src/systems/system-constants.js